import { FETCH_SUCCESS, TABLE_UPDATE } from "../types";
import { MANAGE_TABLE } from "app/ManageTables/types";
import { tableResponse, tableUpdate } from "helpers/reducers";
import trans from "helpers/trans";
import { AnyAction } from "redux";
import { IGPTable } from "ui/Table/Table";

function AccountGroupsTable(
    state: IGPTable = {
        id: "AccountGroupsTable",
        columns: [
            {
                field: "account_group_id",
                headName: trans("inv.AccountGroups.fields.account_group_id"),
            },
            {
                field: "name",
                headName: trans("inv.AccountGroups.fields.name"),
            },
            {
                field: "categories",
                headName: trans("inv.AccountGroups.fields.categories"),
            },
        ],
        availableColumns: [],
        filters: {},
        filterSettings: {
            open: false,
            total: 0,
        },
        pagination: {
            page: 1,
            per_page: 20,
            isLastPage: true,
            total: 0,
        },
        search: "",
        selection: {
            id: "id",
            selected: [],
        },
        selectionActions: null,
        sort: { account_group_id: "asc" },
        with: ["categories"],
    },
    action: AnyAction,
) {
    switch (action.type) {
        case FETCH_SUCCESS:
            if (action.response.config.params._table_id === state.id) {
                return tableResponse(state, action);
            }
            return state;

        case MANAGE_TABLE:
            if (action.data.id === state.id) {
                return {
                    ...state,
                    ...action.data,
                };
            }
            return state;

        case TABLE_UPDATE:
            return tableUpdate(state, action);
        default:
            return state;
    }
}

export default AccountGroupsTable;
